import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { getAuth, signInWithEmailLink } from 'firebase/auth';

export default function Login() {
  const [email, setEmail] = useState(new URLSearchParams(window.location.search).get('email') || '');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const { sendMagicLink } = useAuth();
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get('mode');
    const oobCode = params.get('oobCode');
    const url = window.location.href;

    if (mode === 'signIn' && oobCode) {
      setStatus('completing');
      let emailForSignIn = window.localStorage.getItem('emailForSignIn');

      if (!emailForSignIn) {
        emailForSignIn = window.prompt('Please confirm your email address:');
      }

      if (!emailForSignIn) {
        setError('Email address required.');
        setStatus('idle');
        return;
      }

      emailForSignIn = emailForSignIn.trim().toLowerCase();

      signInWithEmailLink(auth, emailForSignIn, url)
        .then(() => {
          window.localStorage.removeItem('emailForSignIn');
          navigate('/dashboard', { replace: true });
        })
        .catch((err) => {
          setError(`Error: ${err.code} — ${err.message}`);
          setStatus('idle');
        });
    }
  }, []);

  async function handleSend(e) {
    e.preventDefault();
    if (!email) { setError('Please enter your email address.'); return; }
    setStatus('sending');
    setError('');
    try {
      await sendMagicLink(email);
      setStatus('sent');
    } catch (err) {
      setError('Could not send link: ' + err.message);
      setStatus('idle');
    }
  }

  if (status === 'completing') {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center',
        justifyContent:'center', flexDirection:'column', gap:16, padding:16 }}>
        <div className="spinner" />
        <p style={{ color:'var(--text-muted)' }}>Signing you in...</p>
        {error && <div className="error-msg" style={{ maxWidth:400 }}>{error}</div>}
      </div>
    );
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:64, height:64, background:'var(--green-dark)', borderRadius:16,
            display:'flex', alignItems:'center', justifyContent:'center',
            margin:'0 auto 16px', fontSize:28 }}>🌿</div>
          <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'var(--green-dark)' }}>Garden & Groundworks</h1>
          <p style={{ color:'var(--text-muted)', marginTop:4, fontSize:'0.9rem' }}>Client portal</p>
        </div>
        <div className="card">
          {status === 'sent' ? (
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:16 }}>📧</div>
              <h2 style={{ marginBottom:12 }}>Check your email</h2>
              <p style={{ color:'var(--text-secondary)', marginBottom:20 }}>
                We've sent a sign-in link to <strong>{email}</strong>. Tap the link to access your account.
              </p>
              <hr className="divider" />
              <button className="btn-secondary" onClick={() => setStatus('idle')} style={{ marginTop:8 }}>
                Use a different email
              </button>
            </div>
          ) : (
            <>
              <h2 style={{ marginBottom:8 }}>Sign in</h2>
              {error && <div className="error-msg">{error}</div>}
              <form onSubmit={handleSend}>
                <div className="form-group">
                  <label>Email address</label>
                  <input type="email" value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="your@email.com" autoFocus />
                </div>
                <button type="submit" className="btn-primary" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Sending...' : 'Send sign-in link'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
